module.exports = __webpack_public_path__ + "static/media/eple_grey-min.fbef8bae.png";